export const IS_REACT_NATIVE = window.ReactNativeWebView !== undefined;
export const IS_WEB = !IS_REACT_NATIVE;
